import type { ClientInferRequest } from "@ts-rest/core";

import { client } from "../client";
import { type apiContract } from "../contract";

export type CreatePosLogRequest = ClientInferRequest<
  typeof apiContract.v1.pos.logs.create
>["body"];

export type CashDrawerTrigger = NonNullable<
  CreatePosLogRequest["payload"]["trigger"]
>;

export async function createCashDrawerOpenPosLog(
  payload: CreatePosLogRequest["payload"]
) {
  const response = await client.v1.pos.logs.create({
    body: {
      type: "cash-drawer-opened",
      payload
    }
  });

  if (response.status === 204) {
    return response.body;
  }

  throw response;
}
